import * as React from 'react';
import Fancybox from './fancybox';


import './galery.scss';


  export default function Galery(){


    return(
        <>
          <section id="project-section">
            <div className='galery-row'>
                <h1>Galeria de fotos</h1>
              <Fancybox>
                <div className="galery-photos">
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/dipm/1024x768/1.jpg" >
                    <img alt="" src="https://gruposeculos.com.br/files/dipm/300x320/1.jpg" className='img-fluid' 
                    data-aos="fade-up"
                    data-aos-duration="1000"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/dipm/1024x768/2.jpg" >
                    <img alt="" src="https://gruposeculos.com.br/files/dipm/300x320/2.jpg" className='img-fluid' 
                    data-aos="fade-up"
                    data-aos-duration="1000"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/dipm/1024x768/3.jpg" >
                    <img alt="" src="https://gruposeculos.com.br/files/dipm/300x320/3.jpg" className='img-fluid' 
                    data-aos="fade-up"
                    data-aos-duration="1000"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/dipm/1024x768/4.jpg" >
                    <img alt="" src="https://gruposeculos.com.br/files/dipm/300x320/4.jpg" className='img-fluid' 
                    data-aos="fade-up"
                    data-aos-duration="1000"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/dipm/1024x768/5.jpg" >
                    <img alt="" src="https://gruposeculos.com.br/files/dipm/300x320/5.jpg" className='img-fluid' 
                    data-aos="fade-up"
                    data-aos-duration="1000"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/dipm/1024x768/6.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/dipm/300x320/6.jpg" className='img-fluid'
                      data-aos="fade-up"
                      data-aos-duration="1000"
                    />
                  </a>
                  
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/dipm/1024x768/7.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/dipm/300x320/7.jpg" className='img-fluid'
                      data-aos="fade-up"
                      data-aos-duration="1000"
                      />
                  </a>
                  
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/dipm/1024x768/8.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/dipm/300x320/8.jpg" className='img-fluid'
                      data-aos="fade-up"
                      data-aos-duration="1000"
                    />
                  </a>
                  
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/dipm/1024x768/9.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/dipm/300x320/9.jpg" className='img-fluid'
                      data-aos="fade-up"
                      data-aos-duration="1000"
                    />
                  </a>

                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/dipm/1024x768/10.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/dipm/300x320/10.jpg" className='img-fluid'
                      data-aos="fade-up"
                      data-aos-duration="1000"
                    />
                  </a>
                </div>
              </Fancybox>

            </div>
          </section>
        </>
    )
}

